import { Gender, LinkType, ResourceDefinition } from '@case-app/angular-library'

export const monitoringProfitabilityDefinition: ResourceDefinition = {
  title: 'Rentabilité - Monitoring',
  nameSingular: 'NOT APPLICABLE',
  namePlural: 'Rentabilité',
  gender: Gender.Feminine,
  mainIdentifier: 'NOT APPLICABLE',
  slug: 'monitoring/profitability',
  path: 'monitoring/profitability',
  className: 'NOT APPLICABLE',
  icon: 'NOT APPLICABLE',
  hasDetailPage: false,
  hasListPage: true,
  buttons: [],
  defaultLink: LinkType.EDIT,
  childrenThatPreventDelete: [],
  dropdownLinks: [],
  keyNumbers: []
}
